import React from 'react';
import { Container, TrainFront, Plane, Ship, Truck, Droplets, FileText, FileCheck, MapPin } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

// Mock data with translations
const servicesData = {
  tr: [
    { id: 1, title: 'İntermodal', description: 'Çok modlu taşımacılık çözümleri', icon: 'Container' },
    { id: 2, title: 'Demir Yolu', description: 'Demiryolu taşımacılığı hizmetleri', icon: 'TrainFront' },
    { id: 3, title: 'Hava Yolu', description: 'Hızlı hava kargo çözümleri', icon: 'Plane' },
    { id: 4, title: 'Deniz Yolu', description: 'Deniz yolu taşımacılığı', icon: 'Ship' },
    { id: 5, title: 'Kara Yolu', description: 'Karayolu taşımacılık hizmetleri', icon: 'Truck' },
    { id: 6, title: 'Likit Taşımacılık', description: 'Sıvı madde taşımacılığı', icon: 'Droplets' },
    { id: 7, title: 'Kontrat Lojistiği', description: 'Sözleşmeli lojistik hizmetleri', icon: 'FileText' },
    { id: 8, title: 'Gümrükleme', description: 'Gümrük işlemleri ve danışmanlık', icon: 'FileCheck' },
    { id: 9, title: 'Yurt İçi Taşımacılık', description: 'Türkiye geneli taşımacılık', icon: 'MapPin' }
  ],
  en: [
    { id: 1, title: 'Intermodal', description: 'Multimodal transportation solutions', icon: 'Container' },
    { id: 2, title: 'Railway', description: 'Railway transportation services', icon: 'TrainFront' },
    { id: 3, title: 'Air Freight', description: 'Fast air cargo solutions', icon: 'Plane' },
    { id: 4, title: 'Sea Freight', description: 'Sea freight services', icon: 'Ship' },
    { id: 5, title: 'Road Transport', description: 'Road transportation services', icon: 'Truck' },
    { id: 6, title: 'Liquid Transport', description: 'Liquid cargo transportation', icon: 'Droplets' },
    { id: 7, title: 'Contract Logistics', description: 'Contracted logistics services', icon: 'FileText' },
    { id: 8, title: 'Customs Clearance', description: 'Customs operations and consultancy', icon: 'FileCheck' },
    { id: 9, title: 'Domestic Transport', description: 'Turkey-wide transportation', icon: 'MapPin' }
  ]
};

const iconMap = {
  Container,
  TrainFront,
  Plane,
  Ship,
  Truck,
  Droplets,
  FileText,
  FileCheck,
  MapPin
};

const ServicesSection = () => {
  const { t, language } = useLanguage();
  const services = servicesData[language];
  
  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#36344D] mb-4">
            {t('services.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <a
                key={service.id}
                href={`#service-${service.id}`}
                className="group bg-white rounded-lg p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-[#DF6A6A]"
              >
                <div className="flex flex-col items-center text-center">
                  <div className="w-16 h-16 bg-[#DF6A6A]/10 rounded-full flex items-center justify-center mb-4 group-hover:bg-[#DF6A6A] transition-colors duration-300">
                    <IconComponent className="w-8 h-8 text-[#DF6A6A] group-hover:text-white transition-colors duration-300" />
                  </div>
                  <h3 className="text-xl font-bold text-[#36344D] mb-2 group-hover:text-[#DF6A6A] transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 text-sm">{service.description}</p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;